(function () {
	const initSlider = (root = document) => {
		const sliders = root.querySelectorAll(".product-card-js");

		sliders.forEach((slider) => {
			if (slider.swiper) return;
			const paginationEl = slider.querySelector(
				".product-pagination .swiper-pagination"
			);
			const nextEl = slider.querySelector(
				".product-button-group .swiper-button-next"
			);
			const prevEl = slider.querySelector(
				".product-button-group .swiper-button-prev"
			);
			if (!paginationEl || !nextEl || !prevEl) return;
			new Swiper(slider, {
				pagination: {
					el: paginationEl,
					clickable: true,
				},
				navigation: {
					nextEl: nextEl,
					prevEl: prevEl,
				},
				allowTouchMove: true,
				breakpoints: {
					990: {
						allowTouchMove: false,
					},
				},
			});
		});
	};

	window.initProductCardSliders = initSlider;

	initSlider();

	document.addEventListener("shopify:section:load", function () {
		initSlider();
	});
})();
